<p>setup-wizard-view-previous-job-details works!</p>
